(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('ReportFileBuilder', ReportFileBuilder);

    ReportFileBuilder.$inject = ['Excel'];
    /* @ngInject */
    function ReportFileBuilder(excel) {
        return {
            exportToExcel: exportToExcel,
            exportToPdf: exportToPdf
        };

        function exportToExcel(fileName, tableId, colIndexToRemove, tableHtml) {
            if (!tableHtml) {
                var clonedTable = $(tableId).clone(true);
                if (colIndexToRemove) {
                    $(clonedTable).find('tr').find('td:eq(' + colIndexToRemove + '),th:eq(' + colIndexToRemove + ')').remove();
                }
                tableHtml = clonedTable.html();
            }
            excel.downloadExcel(tableId, fileName + '.csv', tableHtml);
        }

        function exportToPdf(fileName, tableId, filters) {
            var rows = [];

            $.each($(tableId + ' tr'), function (i, row) {
                var cols = [];
                $.each($(row).find("td, th"), function (j, cell) {
                    var oCell = $(cell);
                    var txt = oCell.text().trim() || " ";
                    var img = oCell.find('img')[0];
                    if (img) {
                        cols.push({ image: img.src });
                    }
                    else {
                        cols.push(txt);
                    }
                });
                rows.push(cols);
            });


            var docHeader = fileName + " - ";
            docHeader += moment(filters.fromDate).format("MM/DD/YYYY") + " - " + moment(filters.toDate).format("MM/DD/YYYY");

            var docDefinition = {
                header: { text: docHeader, margin: [5, 5, 0, 0] },
                footer: function (currentPage, pageCount) { return { text: currentPage.toString() + ' of ' + pageCount, alignment: 'right', margin: [0, 0, 5, 0] }; },
                pageOrientation: 'landscape',
                content: [
                    {
                        table: {
                            // headers are automatically repeated if the table spans over multiple pages
                            // you can declare how many rows should be treated as headers
                            headerRows: 1,
                            body: rows,
                            dontBreakRows: true
                        }
                    }
                ]
            };
            
            pdfMake.createPdf(docDefinition).download(docHeader + ".pdf");
            
        }

      
    }
})();
